module.exports = __webpack_public_path__ + "a321fff0ecea174901e2ed9feb262e88.svg";